module.exports = __webpack_public_path__ + "img/mebeki.cc4d44d5.jpeg";